<template>
  <div class="form_toolbar">
    <div class="tool_search">
      <a-form
        layout="inline"
        :form="form"
        @submit="handleSearch"
      >
        <a-form-item :label="`${formTit}：`">
          <a-select
            v-decorator="[
              'formid',{
                initialValue: query.formid
              }
            ]"
            :show-search="true"
            allow-clear
            change-on-select
            :placeholder="selectSearchPlace"
            :filter-option="filterForm"
          >
            <a-select-option
              v-for="(item) in formCategory"
              :key="`${item.name}`"
              :value="item.formid"
            >
              <a-tooltip
                placement="rightTop"
                :destroy-tooltip-on-hide="true"
              >
                <template slot="title">
                  {{ item.name }}
                </template>
                {{ item.name }}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- v-if="level !== 0" -->
        <a-form-item :label="`${developerTitTxt}：`">
          <div class="developer">
            <a-cascader
              v-decorator="[
                'ids', {
                  initialValue: [],
                  rules: [{validator: isSelectedUser}]
                }
              ]"
              :options="formatCascader"
              change-on-select
              :show-search="true"
              :placeholder="selectSearchPlace"
            />
          </div>
        </a-form-item>
        <div style="display: inline-block">
          <a-form-item :label="`${subTimeTit}：`">
            <div class="picker">
              <a-range-picker v-decorator="['range_picker']" />
            </div>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["91"]') }}
            </a-button>
            <a-button @click="resetForm">
              {{ $t('message["1625"]') }}
            </a-button>
          </a-form-item>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapActions, mapMutations } from 'vuex'
import { isSelectedUser } from '../common'
export default {
  props: {
    level: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('smart/submit', ['formCategory', 'subQuery']),
    ...mapState('smart/manage', ['developerList']),
    formatCascader () {
      return this.perpareCascader(this.developerList)
    },
    query () {
      let params = Object.assign({}, this.subQuery)
      return params
    },
    developerTitTxt () {
      return this.$t('message["549"]')
    },
    selectSearchPlace () {
      return this.$t('message["866"]')
    },
    formTit () {
      return this.$t('message["1157"]')
    },
    subTimeTit () {
      return this.$t('message["1170"]')
    }
  },
  async created () {
    await this.fetchFormCategory()
  },
  methods: {
    ...mapActions('smart/submit', ['fetchFormCategory']),
    ...mapMutations('smart/submit', ['SET_SUB_QUERY']),
    isSelectedUser,
    filterForm (value, option) {
      const { key } = option
      return key.indexOf(value) >= 0
    },
    // 查询
    handleSearch (e) {
      e.preventDefault()
      const _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          let fieldsValue = Object.assign({}, values)
          const { 'range_picker': date, ids } = fieldsValue
          if (ids && ids.length > 0) {
            ids.forEach(item => {
              let aItem = item.split('-')
              let aItemValue = aItem[1] === '+1' ? '-1' : Number(aItem[1])
              Object.assign(fieldsValue, { [aItem[0]]: aItemValue })
            })
          }
          delete fieldsValue['ids']
          if (date && date.length > 0) {
            let startTime = (new Date(date[0].format('YYYY-MM-DD')).getTime()).toString()
            let endTime = (new Date(date[1].format('YYYY-MM-DD')).getTime()).toString()
            startTime = startTime.slice(0, 10)
            endTime = endTime.slice(0, 10)
            Object.assign(fieldsValue, { start_time: startTime }, { end_time: endTime })
            delete fieldsValue['range_picker']
          }
          let params = _this.filterParams(fieldsValue)
          let { tab, limit, page } = _this.$route.query
          _this.$router.push({
            query: {
              tab,
              limit,
              page,
              ...params
            }
          })
          _this.$emit('search', params)
        }
      })
    },
    // 重置表单
    resetForm () {
      this.form.resetFields()
      this.SET_SUB_QUERY({})
      this.$emit('reset')
    },
    filterParams (params) {
      for (let key in params) {
        if (typeof params[key] === 'undefined') {
          delete params[key]
        }
      }
      return params
    },
    // 准备开发人员下拉数据
    perpareCascader (data) {
      let result = []
      if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let obj = {}
          obj.label = item.name
          obj.key = item.keyname + '-' + item.id
          if ('children' in item && item.children.length > 0) {
            obj.key = item.keyname + '-' + item.id
            obj.children = this.perpareCascader(item.children)
          } else {
            obj.key = item.keyname + '-' + item.id
          }
          obj.value = (item.keyname + '-' + item.id).toString()
          result.push(obj)
        }
      }
      return result
    }
  }
}
</script>

<style scoped lang="scss">
.form_toolbar {
  width: 100%;
  margin: 24px auto 0 auto;
  button {
    display: inline-block;
  }
}
.action_list {
  li {
    line-height: 24px;
    padding: 4px 12px;
  }
  li:hover {
    cursor: pointer;
    background: #f4f7f9;
    border-radius: 4px;
  }
}
.tool_search {
  vertical-align: middle;
  .developer {
    ::v-deep .ant-select,
    form .ant-cascader-picker,
    .ant-cascader-picker {
      width: 320px;
    }
  }
  .picker {
    ::v-deep .ant-input {
      width: 320px;
    }
  }
  ::v-deep .ant-select {
    width: 320px;
  }
  ::v-deep .ant-select:first-of-type {
    width: 320px;
  }
  ::v-deep .ant-form-item {
    margin-bottom: 24px;
    margin-right: 48px;
  }
  ::v-deep .ant-form-item:last-of-type {
    margin-right: 0;
  }
}
</style>
